import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@material-ui/core'
import FormContainer from '../../Form/FormContainer'

const PasswordResetSuccess = () => {
  const history = useHistory()

  return (
    <div className="login flex">
      <div
        className="bg-image"
        style={{ backgroundImage: "url('/images/login-bg.jpg')" }}
      ></div>
      <FormContainer>
        <h2>Success!</h2>
        <p className="fs14">
          You have successfully reset your MyQuality account password. Sign in
          to access your account.{' '}
        </p>

        <div className="flex flex-end m-t-40">
          <Button
            variant="contained"
            color="primary"
            onClick={() => history.push('/login')}
          >
            Return to sign in
          </Button>
        </div>
      </FormContainer>
    </div>
  )
}

export default PasswordResetSuccess
